<template>
  <svg width="8"
       height="20"
       viewBox="0 0 8 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M4 19.7598C4.36035 19.7598 4.91406 18.292 4.91406 15.9189V7.63965C6.39941 7.23535 7.48047 5.87305 7.48047 4.26465C7.48047 2.33105 5.93359 0.757812 4 0.757812C2.05762 0.757812 0.510742 2.33105 0.510742 4.26465C0.510742 5.86426 1.58301 7.22656 3.06836 7.63086V15.9189C3.06836 18.2744 3.63086 19.7598 4 19.7598ZM2.99805 4.45801C2.36523 4.45801 1.81152 3.9043 1.81152 3.25391C1.81152 2.6123 2.36523 2.06738 2.99805 2.06738C3.65723 2.06738 4.19336 2.6123 4.19336 3.25391C4.19336 3.9043 3.65723 4.45801 2.99805 4.45801Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'DemoIcon',
  props: {
    width: {
      type: Number,
      default: 11
    },
    height: {
      type: Number,
      default: 10
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
